import { z } from "zod";
import { IdType } from "./base.validator";

const filePermission = z.enum(["public", "account"]);

export const fileMeta = z.object({
	id: IdType,
	permission: filePermission,
	fileName: z.string(),
	originalFileName: z.string(),
	url: z.string(),
	fileSize: z.number(),
	contentType: z.string(),
	uploaderId: IdType,
});
export type FileMetaDto = z.infer<typeof fileMeta>;

export const fileUploadInput = z.object({
	file: z.instanceof(File),
	permission: filePermission,
});
export type FileUploadInputDto = z.infer<typeof fileUploadInput>;
